<ng-container [ngSwitch]="phxState">
  <div *ngSwitchCase="'edit'" cdkDropList [cdkDropListData]="list$ | async" (cdkDropListDropped)="dropHandler($event)"
    class="phx-draggable-list-container">
    <div *ngFor="let item of list$ | async; let index=index" cdkDrag class="phx-draggable-list-row" [class.phx-draggable-list-drag-preview]="dragHandleFocusIndex === index">
      <div class="phx-draggable-list-handle-container" [ngStyle]="alignmentAnchors[index]">
        <button
          #dragHandle cdkDragHandle phx-button phxButtonType="icon" phxSize="small" [phxPrefixIcon]="dragIcon"
          (focus)="dragHandleFocusHandler(index)" (blur)="dragHandleFocusHandler(null)" class="phx-draggable-list-handle"
        ></button>
      </div>
      <div #itemTemplateWrapper class="phx-draggable-list-item">
        <ng-container [ngTemplateOutlet]="phxItemTemplate"
          [ngTemplateOutletContext]="{ item: item, index: index }"></ng-container>
      </div>
      <div *ngIf="phxDeleteButtonVisible" class="phx-draggable-list-delete-button-container" [ngStyle]="alignmentAnchors[index]">
        <button phx-button phxButtonType="icon" phxSize="small" [phxPrefixIcon]="crossIcon"
          [disabled]="item.phxSettings?.deleteButtonDisabled" phx-tooltip
          [phxTrigger]="item.phxSettings?.deleteButtonDisabled && item.phxSettings?.deleteButtonDisabledTooltipText ? 'hover' : 'none'"
          [phxTitle]="item.phxSettings?.deleteButtonDisabledTooltipText" (click)="deleteHandler(index)"
        ></button>
      </div>
    </div>

    <div *ngIf="phxInsertButtonVisible" class="phx-draggable-list-insert-button-container">
      <button phx-button phxButtonRole="secondary" [phxPrefixIcon]="plusIcon" [disabled]="phxInsertButtonDisabled"
        phx-tooltip [phxTrigger]="phxInsertButtonDisabled && phxInsertButtonDisabledTooltipText ? 'hover' : 'none'"
        [phxTitle]="phxInsertButtonDisabledTooltipText"
        (click)="insertHandler()">
        {{ phxInsertText || ('Add Another' | phxTranslate) }}
      </button>
    </div>
  </div>

  <div *ngSwitchCase="'view'" class="phx-draggable-list-container">
    <div *ngFor="let item of list$ | async; let index=index" class="phx-draggable-list-row">
      <div class="phx-draggable-list-item-number-container">{{ index + 1 }}.</div>
      <div class="phx-draggable-list-item">
        <ng-container [ngTemplateOutlet]="phxItemTemplate"
          [ngTemplateOutletContext]="{ item: item, index: index }"></ng-container>
      </div>
    </div>
  </div>
</ng-container>